'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactSpectraEditor = require('@complat/react-spectra-editor');

var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _Tooltip = require('@material-ui/core/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _Button = require('@material-ui/core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _FileCopyOutlined = require('@material-ui/icons/FileCopyOutlined');

var _FileCopyOutlined2 = _interopRequireDefault(_FileCopyOutlined);

var _action_file = require('../actions/action_file');

var _action_predict = require('../actions/action_predict');

var _action_desc = require('../actions/action_desc');

var _action_jcamp = require('../actions/action_jcamp');

var _helper = require('../utils/helper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var titleStyle = {
  backgroundColor: '#f5f5f5',
  border: '2px solid #e3e3e3',
  borderRadius: '10px',
  height: 250,
  lineHeight: '250px',
  marginTop: 100,
  textAlign: 'center'
};

var txtStyle = {
  lineHeight: '200px'
};

var containerStyle = {
  margin: '5px 0 0 0'
};

var W = Math.round(window.innerWidth * 0.90 * 9 / 12); // ROI

var editorStyle = {
  border: '1px solid gray',
  borderRadius: '8px 0 0 8px',
  margin: '0 0 0 60px',
  width: W - 80
};

var editorBtnStyle = {
  border: '1px solid gray',
  borderRadius: '0 8px 8px 0',
  margin: '0 0 0 0',
  width: 40,
  verticalAlign: 'top'
};

var renderTitle = function renderTitle() {
  return _react2.default.createElement(
    'div',
    { style: titleStyle },
    _react2.default.createElement(
      'h1',
      { style: txtStyle },
      _react2.default.createElement(
        'p',
        null,
        'Welcome to ChemSpectra'
      ),
      _react2.default.createElement(
        'a',
        {
          target: '_blank',
          rel: 'noopener noreferrer',
          href: 'https://github.com/ComPlat/react-spectra-editor/blob/master/DEMO_MANUAL.md'
        },
        'Step by step demo'
      )
    )
  );
};

var Content = function (_React$Component) {
  _inherits(Content, _React$Component);

  function Content(props) {
    _classCallCheck(this, Content);

    var _this = _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).call(this, props));

    _this.writeMpy = _this.writeMpy.bind(_this);
    _this.writePeak = _this.writePeak.bind(_this);
    _this.formatPks = _this.formatPks.bind(_this);
    _this.formatMpy = _this.formatMpy.bind(_this);
    _this.checkWriteOp = _this.checkWriteOp.bind(_this);
    _this.saveOp = _this.saveOp.bind(_this);
    _this.refreshOp = _this.refreshOp.bind(_this);
    _this.predictOp = _this.predictOp.bind(_this);
    // this.updatInput = this.updatInput.bind(this);
    _this.buildOpsByLayout = _this.buildOpsByLayout.bind(_this);
    _this.buildForecast = _this.buildForecast.bind(_this);
    _this.buildOthers = _this.buildOthers.bind(_this);
    return _this;
  }

  _createClass(Content, [{
    key: 'formatPks',
    value: function formatPks(_ref) {
      var peaks = _ref.peaks,
          layout = _ref.layout,
          shift = _ref.shift,
          isAscend = _ref.isAscend,
          decimal = _ref.decimal,
          isIntensity = _ref.isIntensity,
          integration = _ref.integration;
      var fileSt = this.props.fileSt;

      var _FN$buildData = _reactSpectraEditor.FN.buildData(fileSt.jcamp),
          entity = _FN$buildData.entity;

      var features = entity.features;

      var _ref2 = Array.isArray(features) ? {} : features.editPeak || features.autoPeak,
          maxY = _ref2.maxY,
          minY = _ref2.minY;

      var boundary = { maxY: maxY, minY: minY };
      var body = _reactSpectraEditor.FN.peaksBody({
        peaks: peaks, layout: layout, decimal: decimal, shift: shift, isAscend: isAscend, isIntensity: isIntensity, boundary: boundary, integration: integration
      });
      var wrapper = _reactSpectraEditor.FN.peaksWrapper(layout, shift);
      var desc = (0, _helper.RmDollarSign)(wrapper.head) + body + wrapper.tail;
      return desc;
    }
  }, {
    key: 'formatMpy',
    value: function formatMpy(_ref3) {
      var multiplicity = _ref3.multiplicity,
          integration = _ref3.integration,
          shift = _ref3.shift,
          isAscend = _ref3.isAscend,
          decimal = _ref3.decimal,
          layout = _ref3.layout;

      // obsv freq
      var fileSt = this.props.fileSt;

      var _FN$buildData2 = _reactSpectraEditor.FN.buildData(fileSt.jcamp),
          entity = _FN$buildData2.entity;

      var features = entity.features;

      var _ref4 = Array.isArray(features) ? features[0] : features.editPeak || features.autoPeak,
          observeFrequency = _ref4.observeFrequency;

      var freq = observeFrequency;
      var freqStr = freq ? parseInt(freq, 10) + ' MHz, ' : '';
      // multiplicity
      var refArea = integration.refArea,
          refFactor = integration.refFactor;

      var shiftVal = multiplicity.shift;
      var ms = multiplicity.stack;
      var is = integration.stack;

      var macs = ms.map(function (m) {
        var peaks = m.peaks,
            mpyType = m.mpyType,
            xExtent = m.xExtent;
        var xL = xExtent.xL,
            xU = xExtent.xU;

        var it = is.filter(function (i) {
          return i.xL === xL && i.xU === xU;
        })[0] || { area: 0 };
        var area = it.area * refFactor / refArea;
        var center = _reactSpectraEditor.FN.calcMpyCenter(peaks, shiftVal, mpyType);
        var xs = m.peaks.map(function (p) {
          return p.x;
        }).sort(function (a, b) {
          return a - b;
        });

        var _ref5 = isAscend ? [0, xs.length - 1] : [xs.length - 1, 0],
            _ref6 = _slicedToArray(_ref5, 2),
            aIdx = _ref6[0],
            bIdx = _ref6[1];

        var mxA = mpyType === 'm' ? (xs[aIdx] - shiftVal).toFixed(decimal) : 0;
        var mxB = mpyType === 'm' ? (xs[bIdx] - shiftVal).toFixed(decimal) : 0;
        return Object.assign({}, m, {
          area: area, center: center, mxA: mxA, mxB: mxB
        });
      }).sort(function (a, b) {
        return isAscend ? a.center - b.center : b.center - a.center;
      });
      var str = macs.map(function (m) {
        var c = m.center;
        var type = m.mpyType;
        var it = Math.round(m.area);
        var js = m.js.map(function (j) {
          return 'J = ' + j.toFixed(1) + ' Hz';
        }).join(', ');
        var atomCount = layout === '1H' ? ', ' + it + 'H' : '';
        var location = type === 'm' ? m.mxA + '\u2013' + m.mxB : '' + c.toFixed(decimal);
        return m.js.length === 0 ? location + ' (' + type + atomCount + ')' : location + ' (' + type + ', ' + js + atomCount + ')';
      }).join(', ');
      var _shift$ref = shift.ref,
          label = _shift$ref.label,
          value = _shift$ref.value,
          name = _shift$ref.name;

      var solvent = label ? name.split('(')[0].trim() + ' [' + value.toFixed(decimal) + ' ppm], ' : '';
      return layout + ' NMR (' + freqStr + solvent + 'ppm) \u03B4 = ' + str + '.';
    }
  }, {
    key: 'writeMpy',
    value: function writeMpy(_ref7) {
      var layout = _ref7.layout,
          shift = _ref7.shift,
          isAscend = _ref7.isAscend,
          decimal = _ref7.decimal,
          multiplicity = _ref7.multiplicity,
          integration = _ref7.integration;

      if (['1H', '13C', '19F'].indexOf(layout) < 0) return;
      var desc = this.formatMpy({
        multiplicity: multiplicity, integration: integration, shift: shift, isAscend: isAscend, decimal: decimal, layout: layout
      });
      var updateDescAct = this.props.updateDescAct;

      updateDescAct(desc);
    }
  }, {
    key: 'writePeak',
    value: function writePeak(_ref8) {
      var peaks = _ref8.peaks,
          layout = _ref8.layout,
          shift = _ref8.shift,
          isAscend = _ref8.isAscend,
          decimal = _ref8.decimal,
          isIntensity = _ref8.isIntensity,
          integration = _ref8.integration;

      var desc = this.formatPks({
        peaks: peaks, layout: layout, shift: shift, isAscend: isAscend, decimal: decimal, isIntensity: isIntensity, integration: integration
      });
      var updateDescAct = this.props.updateDescAct;

      updateDescAct(desc);
    }
  }, {
    key: 'checkWriteOp',
    value: function checkWriteOp(_ref9) {
      var peaks = _ref9.peaks,
          layout = _ref9.layout,
          shift = _ref9.shift,
          isAscend = _ref9.isAscend,
          decimal = _ref9.decimal;
      var _props = this.props,
          predictToWriteInitAct = _props.predictToWriteInitAct,
          molSt = _props.molSt,
          fileSt = _props.fileSt;

      var molfile = molSt.src;
      var cleanPeaks = _reactSpectraEditor.FN.rmShiftFromPeaks(peaks, shift);
      predictToWriteInitAct({
        molfile: molfile,
        layout: layout,
        shift: shift,
        isAscend: isAscend,
        decimal: decimal,
        peaks: cleanPeaks,
        spectrum: fileSt.src
      });
    }
  }, {
    key: 'saveOp',
    value: function saveOp(_ref10) {
      var peaks = _ref10.peaks,
          shift = _ref10.shift,
          scan = _ref10.scan,
          thres = _ref10.thres,
          analysis = _ref10.analysis,
          integration = _ref10.integration,
          multiplicity = _ref10.multiplicity,
          waveLength = _ref10.waveLength,
          cyclicvoltaSt = _ref10.cyclicvoltaSt;
      var _props2 = this.props,
          saveFileInitAct = _props2.saveFileInitAct,
          molSt = _props2.molSt;
      var mass = molSt.mass;

      var fPeaks = _reactSpectraEditor.FN.rmRef(peaks, shift);
      var peakStr = _reactSpectraEditor.FN.toPeakStr(fPeaks);
      var predict = JSON.stringify(analysis);

      saveFileInitAct({
        peakStr: peakStr,
        shift: shift,
        mass: mass,
        scan: scan,
        thres: thres,
        predict: predict,
        integration: JSON.stringify(integration),
        multiplicity: JSON.stringify(multiplicity),
        waveLength: JSON.stringify(waveLength),
        cyclicvolta: JSON.stringify(cyclicvoltaSt)
      });
    }
  }, {
    key: 'refreshOp',
    value: function refreshOp(_ref11) {
      var peaks = _ref11.peaks,
          scan = _ref11.scan,
          shift = _ref11.shift,
          thres = _ref11.thres,
          analysis = _ref11.analysis,
          integration = _ref11.integration,
          multiplicity = _ref11.multiplicity;
      var _props3 = this.props,
          refreshFileInitAct = _props3.refreshFileInitAct,
          molSt = _props3.molSt;
      var mass = molSt.mass;

      var fPeaks = _reactSpectraEditor.FN.rmRef(peaks, shift);
      var peakStr = _reactSpectraEditor.FN.toPeakStr(fPeaks);
      var predict = JSON.stringify(analysis);

      refreshFileInitAct({
        peakStr: peakStr,
        shift: shift,
        mass: mass,
        scan: scan,
        thres: thres,
        predict: predict,
        integration: JSON.stringify(integration),
        multiplicity: JSON.stringify(multiplicity)
      });
    }
  }, {
    key: 'getPeaksByLayou',
    value: function getPeaksByLayou(peaks, layout, multiplicity) {
      if (['IR'].indexOf(layout) >= 0) return peaks;
      if (['13C'].indexOf(layout) >= 0) return _reactSpectraEditor.FN.CarbonFeatures(peaks, multiplicity);
      var stack = multiplicity.stack,
          shift = multiplicity.shift;

      var nmrMpyCenters = stack.map(function (stk) {
        var mpyType = stk.mpyType;

        var centers = stk.peaks;
        return {
          x: _reactSpectraEditor.FN.CalcMpyCenter(centers, shift, mpyType),
          y: 0
        };
      });

      var defaultCenters = [{ x: -1000.0, y: 0 }];
      return nmrMpyCenters.length > 0 ? nmrMpyCenters : defaultCenters;
    }
  }, {
    key: 'predictOp',
    value: function predictOp(_ref12) {
      var peaks = _ref12.peaks,
          layout = _ref12.layout,
          shift = _ref12.shift,
          multiplicity = _ref12.multiplicity;
      var _props4 = this.props,
          predictInitAct = _props4.predictInitAct,
          molSt = _props4.molSt,
          fileSt = _props4.fileSt;

      var molfile = molSt.src;

      var targetPeaks = this.getPeaksByLayou(peaks, layout, multiplicity);

      predictInitAct({
        molfile: molfile, peaks: targetPeaks, layout: layout, shift: shift, spectrum: fileSt.src
      });
    }

    // updatInput(e) {
    //   const molecule = e.target.value;
    //   this.setState({ molecule });
    // }

  }, {
    key: 'buildForecast',
    value: function buildForecast() {
      var _props5 = this.props,
          molSt = _props5.molSt,
          predictSt = _props5.predictSt;


      var predictObj = {
        btnCb: this.predictOp,
        refreshCb: this.refreshOp,
        molecule: molSt.src ? molSt.src.name : '',
        predictions: predictSt
      };
      return predictObj;
    }
  }, {
    key: 'buildOpsByLayout',
    value: function buildOpsByLayout(entity, editorOnly) {
      // eslint-disable-line
      var ops = [{ name: 'write peaks', value: this.writePeak }, { name: 'save', value: this.saveOp }];
      if (['1H', '13C', '19F'].indexOf(entity.layout) >= 0) {
        ops = [{ name: 'write multiplicity', value: this.writeMpy }].concat(_toConsumableArray(ops));
      }
      return ops;
      // { name: 'check & write', value: this.checkWriteOp },
    }
  }, {
    key: 'buildOthers',
    value: function buildOthers() {
      var _props6 = this.props,
          addOthersInitAct = _props6.addOthersInitAct,
          othersSt = _props6.othersSt;


      return {
        others: othersSt,
        addOthersCb: addOthersInitAct
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          fileSt = _props7.fileSt,
          descSt = _props7.descSt,
          editorOnly = _props7.editorOnly,
          molSt = _props7.molSt;

      if (!fileSt) return renderTitle();

      var _FN$buildData3 = _reactSpectraEditor.FN.buildData(fileSt.jcamp),
          entity = _FN$buildData3.entity,
          xLabel = _FN$buildData3.xLabel,
          yLabel = _FN$buildData3.yLabel,
          isExist = _FN$buildData3.isExist;

      var currEntity = entity;
      var currXLabel = xLabel;
      var currYLabel = yLabel;

      var multiEntities = false;
      if (!isExist) {
        var jcampList = fileSt.jcampList;

        if (!jcampList || jcampList.length === 0) return renderTitle();
        multiEntities = jcampList.map(function (jcamp) {
          var _FN$buildData4 = _reactSpectraEditor.FN.buildData(jcamp),
              entity = _FN$buildData4.entity,
              xLabel = _FN$buildData4.xLabel,
              yLabel = _FN$buildData4.yLabel;

          currEntity = entity;
          currXLabel = xLabel;
          currYLabel = yLabel;
          return entity;
        });
      }

      // if (!isExist) return renderTitle();

      var svg = molSt.svg;

      var operations = this.buildOpsByLayout(currEntity, editorOnly);
      var forecast = this.buildForecast();
      var others = this.buildOthers();

      return _react2.default.createElement(
        'div',
        { style: containerStyle },
        _react2.default.createElement(_reactSpectraEditor.SpectraEditor, {
          entity: currEntity,
          multiEntities: multiEntities,
          others: others,
          xLabel: currXLabel,
          yLabel: currYLabel,
          forecast: forecast,
          operations: operations,
          editorOnly: editorOnly,
          molSvg: svg
        }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('textarea', {
            rows: '2',
            cols: '180',
            placeholder: 'peaks',
            style: editorStyle,
            value: descSt,
            readOnly: true
          }),
          _react2.default.createElement(
            _Tooltip2.default,
            { title: 'Copy to clipboard' },
            _react2.default.createElement(
              _reactCopyToClipboard.CopyToClipboard,
              { text: descSt },
              _react2.default.createElement(
                _Button2.default,
                {
                  style: editorBtnStyle,
                  variant: 'outlined'
                },
                _react2.default.createElement(_FileCopyOutlined2.default, null)
              )
            )
          )
        )
      );
    }
  }]);

  return Content;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return (// eslint-disable-line
    {
      molSt: state.mol,
      fileSt: state.file,
      predictSt: state.predict,
      descSt: state.desc,
      othersSt: state.jcamp.others
    }
  );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    saveFileInitAct: _action_file.saveFileInit,
    refreshFileInitAct: _action_file.refreshFileInit,
    predictInitAct: _action_predict.predictInit,
    predictToWriteInitAct: _action_predict.predictToWriteInit,
    updateDescAct: _action_desc.updateDesc,
    addOthersInitAct: _action_jcamp.addOthersInit
  }, dispatch);
};

Content.propTypes = {
  molSt: _propTypes2.default.object.isRequired,
  fileSt: _propTypes2.default.object.isRequired,
  predictSt: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]).isRequired,
  descSt: _propTypes2.default.string.isRequired,
  othersSt: _propTypes2.default.array.isRequired,
  saveFileInitAct: _propTypes2.default.func.isRequired,
  refreshFileInitAct: _propTypes2.default.func.isRequired,
  predictInitAct: _propTypes2.default.func.isRequired,
  predictToWriteInitAct: _propTypes2.default.func.isRequired,
  updateDescAct: _propTypes2.default.func.isRequired,
  addOthersAct: _propTypes2.default.func.isRequired,
  editorOnly: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Content);